export default __webpack_public_path__ + "static/media/love-on-my-mind.81d40042.png";